export default function createAction(type) {
  return (payload, callback) => ({ type, payload, callback })
}
